import * as R from 'ramda';
import {
  addfileRepo,
  addfileRepoTest,
  getCourseFileRepo,
  patchFileRepo,
  getCourseFileRepoAudio,
  getCourseFileRepoCatelogue,
  postLearningPathProgress,
} from "../../helpers/api/api";
import {
  started,
  response,
  failure,
  reducer,
  call,
} from '../../helpers/api/meta';

export const POST_FILEREPO = 'POST_FILEREPO';
export const GET_FILEREPO = 'GET_FILEREPO';
export const GET_FILEREPO_AUDIO = 'GET_FILEREPO_AUDIO';
export const GET_FILEREPO_Catelogue = 'GET_FILEREPO_Catelogue';
export const UPDATE_FILEREPO = 'UPDATE_FILEREPO';
export const POST_FILEPROGRESS = 'POST_FILEPROGRESS';
export const GET_RESOURCES_LIBRARY = 'GET_RESOURCES_LIBRARY';

export const callAddfileRepo = (body) => (dispatch) => {
  dispatch(started(POST_FILEREPO));
  return addfileRepo(body)
    .then((success) => {
      dispatch(response(POST_FILEREPO));
      return success;
    })
    .catch((error) => {
      dispatch(failure(POST_FILEREPO, error));
      throw error;
    });
};
export const callAddfileRepoTest = (body) => (dispatch) => {
  dispatch(started(POST_FILEREPO));
  return addfileRepoTest(body)
    .then((success) => {
      dispatch(response(POST_FILEREPO));
      return success;
    })
    .catch((error) => {
      dispatch(failure(POST_FILEREPO, error));
      throw error;
    });
};

export const postFileProgress = (body) => (dispatch) => {
  dispatch(started(POST_FILEPROGRESS));
  return postLearningPathProgress(body)
    .then((success) => {
      dispatch(response(POST_FILEPROGRESS));
      return success;
    })
    .catch((error) => {
      dispatch(failure(POST_FILEPROGRESS, error));
      throw error;
    });
};

export const callPatchFileRepo = (body) => (dispatch) => {
  dispatch(started(UPDATE_FILEREPO));
  return patchFileRepo(body)
    .then((success) => {
      dispatch(response(UPDATE_FILEREPO));
      return success;
    })
    .catch((error) => {
      dispatch(failure(UPDATE_FILEREPO, error));
      throw error;
    });
};

export const callGetFileRepo = (inputs) => {
  const meta = {
    endpoint: (params) => getCourseFileRepo(params),
    inputs,
    action: GET_FILEREPO,
    messages: {
      id: 'getCourseFileRepo',
      failure: 'Could not get file repo data',
    },
  };
  return call(meta);
};

export const callGetFileRepoAudio = (inputs) => {
  const meta = {
    endpoint: (params) => getCourseFileRepoAudio(params),
    inputs,
    action: GET_FILEREPO_AUDIO,
    messages: {
      id: 'getCourseFileRepoAudio',
      failure: 'Could not get file repo audio data',
    },
  };
  return call(meta);
};

export const callGetFileRepoCatelogue = (inputs) => {
  const meta = {
    endpoint: (params) => getCourseFileRepoCatelogue(params),
    inputs,
    action: GET_FILEREPO_Catelogue,
    messages: {
      id: 'getCourseFileRepoCatelogue',
      failure: 'Could not get file repo catelogue data',
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  results: [],
};

const saveFileRepo = (state, action) => {
  return R.assoc('results', action.results, state);
};

const messages = {
  loadFailed: 'Could not load file repo.',
};

export default reducer(
  initialState,
  GET_FILEREPO,
  saveFileRepo,
  messages.loadFailed
);
